import { render, staticRenderFns } from "./penilaian_atasan.vue?vue&type=template&id=2bff5a7c"
import script from "./penilaian_atasan.vue?vue&type=script&lang=js"
export * from "./penilaian_atasan.vue?vue&type=script&lang=js"
import style0 from "./penilaian_atasan.vue?vue&type=style&index=0&id=2bff5a7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports